module.exports = __webpack_public_path__ + "media/application/images/svgs/dribbble-be87823a9818c68e3b758d99ed069433.svg";